import Typography from "Components/CommonComponents/Typography";
import { UserInfoContext } from "Context/CommonContext";
import { useContext } from "react";
import { Col, Row } from "reactstrap";
import "./index.css";
import { IUserInfo } from "utilFunctions/CommonInterfaces/userInterface";
import PDFView from "Pages/AssetView/PDFView";
import VideoView from "Pages/AssetView/VideoView";
import PPTView from "Pages/AssetView/PPTView";

interface IAssetInfo {
  assetId?: number | string;
  courseId?: number | string;
  type?: string;
  desc?: string;
  title?: string;
}
export interface IAssetdata {
  assetId?: number | string;
  courseId?: number | string;
  type?: string;
  desc?: string;
  url?: string;
  title?: string;
}
const AssetView = ({ assetId, courseId, type, title, desc }: IAssetInfo) => {
  const userInfo = useContext<IUserInfo>(UserInfoContext);
  console.log(userInfo, assetId, "scheduleAssetData", type);

  return (
    <div className="assetView">
      <Row className="w-100">
        <Col
          xs="12"
          sm="12"
          md="12"
          className="d-flex flex-row justify-content-center align-items-center"
        >
          {type == "Faculty_Ebook" || type == "Ebook" ? (
            <PDFView assetId={assetId} courseId={courseId} />
          ) : null}
          {type == "Faculty_Video" || type == "Video" || type == "Audio" ? (
            <VideoView assetId={assetId} courseId={courseId} />
          ) : null}
          {type == "Faculty_ppt" || type == "PPT" ? (
            <PPTView assetId={assetId} courseId={courseId} />
          ) : null}
        </Col>
      </Row>

      <Row className="w-100 d-flex flex-row justify-content-start">
        <Col
          xs="12"
          sm="12"
          md="12"
          className="d-flex flex-row justify-content-start"
        >
          <Typography variant="subheading2" color="black">
            Content Title:&nbsp;
          </Typography>
          <Typography variant="h5" color="black">
            {title}
          </Typography>
        </Col>
        {desc ? (
          <Col
            xs="12"
            sm="12"
            md="12"
            className="d-flex flex-row justify-content-start"
          >
            <Typography variant="subheading2" color="black">
              Description:&nbsp;
            </Typography>
            <Typography variant="h5" color="black">
              {desc}
            </Typography>
          </Col>
        ) : null}
      </Row>
    </div>
  );
};

export default AssetView;
